import * as React from 'react';
import ttwLogo from "../../assets/ttw-logo.png";
import styles from './Footer.module.css'

interface FooterProps {
    version: string
}

const Footer = ({version}: FooterProps) => {

    const reload = location.href + "?t=" + new Date().getTime();

    const handleReload = (e) => {
        e.preventDefault(); // Prevent default behavior if needed
        window.location.href = window.location.href + '?t=' + new Date().getTime();
    };

    return (
        <footer className={styles.container}>
            <p className={styles.contact}>
                Need some help? <a
                    href={"https://hubdocs.ttw.com.au/quality/emails/outlook-plugin/"}
                    target="_blank"
                    className={styles.ttw}>
                     Check out the docs
                </a>.
            </p>
            {/* <p className={styles.contact}>
                Comments? Contact <a
                    href={"mailto:hub@ttw.com.au"}
                    className={styles.email}>
                    <span className={styles.ttw}>TTW</span> Digital
                </a>.
            </p> */}
            <p className={styles.version}>{version} <a className={styles.ttw} href="/" onClick={handleReload}>↺</a></p>
        </footer>
    )
};

export default Footer;